// extracted by mini-css-extract-plugin
export default {"card":"Styles_card__GZ6FH","header":"Styles_header__mqsqK","headerContainer":"Styles_headerContainer__2xYJr"};